
document.addEventListener('DOMContentLoaded', () => {
    const wornByYouWrapper = document.querySelector('.okendo-wrapper');

    if (!wornByYouWrapper) return;

    const checkReviews = (okeReviews) => {
        const observer = new MutationObserver(() => {
            const hasChildren = okeReviews.children.length > 0;

            if (!hasChildren) {
                wornByYouWrapper.style.display = 'none';
                observer.disconnect();
            }
        });

        observer.observe(okeReviews, { childList: true });

        if (okeReviews.children.length === 0) {
            wornByYouWrapper.style.display = 'none';
            observer.disconnect();
        }
    };

    const waitForOkeReviews = () => {
        const observer = new MutationObserver(() => {
            const okeReviews = wornByYouWrapper.querySelector('.okeReviews');
            if (okeReviews) {
                observer.disconnect();
                checkReviews(okeReviews);
            }
        });

        observer.observe(wornByYouWrapper, { childList: true, subtree: true });

        setTimeout(() => observer.disconnect(), 10000);
    };

    waitForOkeReviews();
});

document.addEventListener('DOMContentLoaded', () => {
    const btn_parent = document.querySelector('.product__info-container .general-buy-btns');
    const default_add = document.querySelector('.product__info-container .general-buy-btns [name="add"]');
    const fly_button = document.querySelector('.fly-add-to-cart');
    const hero = document.querySelector('.grid__item.product__media-wrapper');
    const footer = document.querySelector('footer.footer');


    if(!default_add || !fly_button || !hero || !footer || btn_parent.classList.contains('hide')) return;


    let isAddBtnVisible = true;
    let isHeroVisible = true;
    let isFooterVisible = false;

    const updateFlyBtnVisibility = () => {
        if (!isAddBtnVisible && !isHeroVisible && !isFooterVisible) {
            fly_button.classList.add('show');
        } else {
            fly_button.classList.remove('show');
        }
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.target === default_add) {
                isAddBtnVisible = entry.isIntersecting;
            }
            if (entry.target === hero) {
                isHeroVisible = entry.isIntersecting;
            }

            if(entry.target === footer) {
                isFooterVisible = entry.isIntersecting;
            }

            updateFlyBtnVisibility();
        });
    }, { threshold: 0 });

    observer.observe(default_add);
    observer.observe(hero);
    observer.observe(footer);
})

document.addEventListener('click', function (e) {
    const target = e.target.closest('[data-variant-id]');
		const url = new URL(window.location.href);
		const params = new URLSearchParams(url.search);

	    if (target) {
	        const variantId = params.get('variant') || target.getAttribute('data-variant-id');
	        const badges = document.querySelectorAll('.variant-badges');
	        badges.forEach(el => {
	            const badgeId = el.getAttribute('data-badges-variant');
							el.classList.add('hidden-badge');
	            if (badgeId === variantId) {
	                el.classList.remove('hidden-badge');
	            }
	        });

				const polarizedBadges = document.querySelectorAll('.polarized-badge');
				polarizedBadges.forEach(el => {
					const badgeId = el.getAttribute('data-polarized-variant');
					el.classList.add('hidden-badge');
					if (badgeId === variantId) {
						el.classList.remove('hidden-badge');
					}
				});
	    }
	});

document.addEventListener('DOMContentLoaded', () => {
    const options = document.querySelectorAll('.product-section__variant-thumbnail');
    const tabs = document.querySelectorAll('.product-section__included-products ');

    if(options && options.length > 0 && tabs && tabs.length > 0) {
        options.forEach(el => {
            el.addEventListener('click', () => {
                tabs.forEach(tab => tab.classList.add('hide'));

                const showTab = Array.from(tabs).find(item => el.dataset.variantId === item.dataset.variantId);

                if(showTab) showTab.classList.remove('hide');

            })
        })
    }
})

const str = 'afterpay';
document.addEventListener('DOMContentLoaded', async () => {
    const { detected_values } = await readUserLocation();

    const afterPayWidget = document.querySelectorAll('.shopify-app-block');

    if(afterPayWidget.length === 0) return;

    afterPayWidget.forEach(widget => {
        if(detected_values?.country?.handle !== 'US' && widget.id.includes('afterpay')) {
            widget.remove();
        }
    })
})

async function readUserLocation() {
    const url = '/browsing_context_suggestions.json';
    const options = {
        method: 'GET'
    }

    try {
        const response = await fetch(url, options);

        return await response.json();
    } catch (error) {
        return error;
    }
}
